<template>
  <modal :isShowing="isShowing" @closed="$emit('cancelled')">
    <h5 class="t-text-md t-font-semibold t-text-gray-900" slot="title">
      {{ title }}
    </h5>

    <form @submit.prevent="submitForm">
      <div class="t-bg-white t-rounded t-px-8 t-pt-6 t-pb-4" slot="body">
        <div class="t-mb-4">
          <label
            class="t-block t-text-gray-500 t-font-bold t-mb-1 md:t-mb-0 t-pr-4"
            for="name-input"
            >Bin Location
          </label>
          <select
            v-model="form.binLocation"
            v-validate="'required'"
            @change="requestBookings"
            name="bin-location"
            class="t-bg-gray-200 t-appearance-none t-border-2 t-border-gray-200 t-rounded t-w-full t-py-2 t-px-4 t-text-gray-700 t-leading-tight focus:t-outline-none focus:t-bg-white focus:t-border-blue-500"
          >
            <option value="" disabled>Select Bin Location</option>
            <option
              v-for="binLocation in binLocationsData"
              :key="binLocation.id"
              :value="binLocation.id"
            >
              {{ binLocation.name }} ({{ binLocation.depot.name }})
            </option>
          </select>
          <div
            v-show="errors.has('bin-location')"
            class="t-text-red-500 t-text-sm"
          >
            Please select a bin location
          </div>
        </div>
        <div class="t-mb-4">
          <label
            class="t-block t-text-gray-500 t-font-bold t-mb-1 md:t-mb-0 t-pr-4"
            for="name-input"
            >Booking</label
          >
          <select
            :disabled="isLoading"
            v-model="form.booking"
            v-validate="'required'"
            name="booking"
            class="t-bg-gray-200 t-appearance-none t-border-2 t-border-gray-200 t-rounded t-w-full t-py-2 t-px-4 t-text-gray-700 t-leading-tight focus:t-outline-none focus:t-bg-white focus:t-border-blue-500"
            :class="{
              't-cursor-not-allowed': isLoading
            }"
          >
            <option value="" disabled>Select Booking</option>
            <option
              v-for="booking in bookings"
              :key="booking.id"
              :value="booking.id"
            >
              {{ booking.number }}
            </option>
          </select>
          <div v-show="errors.has('booking')" class="t-text-red-500 t-text-sm">
            Please select a booking
          </div>
        </div>
      </div>
      <div class="t-flex t-items-center t-justify-end t-px-8 t-pb-4">
        <button
          @click="$emit('cancelled')"
          type="button"
          class="t-bg-gray-500 hover:t-bg-gray-700 t-text-white t-font-bold t-py-2 t-px-4 t-mx-2 t-rounded focus:t-outline-none focus:t-shadow-outline"
          data-dismiss="modal"
        >
          Close
        </button>
        <button
          :disabled="isSaving"
          type="submit"
          class="t-bg-green-500 hover:t-bg-green-700 t-text-white t-font-bold t-py-2 t-px-4 t-mx-2 t-rounded focus:t-outline-none focus:t-shadow-outline"
        >
          <i v-if="isSaving" class="fa fa-spinner fa-spin"></i>
          <span v-else>Save</span>
        </button>
      </div>
    </form>
  </modal>
</template>

<script>
import Modal from "../../utils/Modal";

export default {
  name: "DepotBinLocationsForm",
  components: {
    Modal
  },
  props: ["isShowing", "depotBinLocation", "binLocationsData"],
  emits: ["cancelled", "serverError"],
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      isLoading: false,
      form: {
        binLocation: !this.depotBinLocation
          ? ""
          : this.depotBinLocation.bin_location_id,
        booking: !this.depotBinLocation ? "" : this.depotBinLocation.booking_id
      },
      isUpdating: this.depotBinLocation !== null,
      isSaving: false,
      binLocations: null,
      bookings: null,
      depots: null
    };
  },
  mounted() {
    if (this.isUpdating) {
      this.requestBookings();
    }
  },
  methods: {
    requestBookings() {
      this.isLoading = true;

      if (this.depotBinLocation) {
        if (this.form.binLocation === this.depotBinLocation.bin_location_id) {
          this.form.booking = this.depotBinLocation.booking_id;
        } else {
          this.form.booking = "";
        }
      } else {
        this.form.booking = "";
      }

      axios
        .get("/depot/bookings-by-binlocation/" + this.form.binLocation)
        .then(response => {
          this.bookings = response.data;
          this.isLoading = false;
        });
    },

    submitForm() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.saving = true;
          this.saveBinLocation().then(res => {
            this.saving = false;
          });
        }
      });
    },

    /**
     * Sends a request to create or edit a new user.
     */
    async saveBinLocation() {
      try {
        let endPoint = !this.isUpdating
          ? "/depot/booking-binlocation"
          : "/depot/booking-binlocation/" + this.depotBinLocation.id;
        let data = {
          bin_location: this.form.binLocation,
          booking: this.form.booking,
          depot: this.form.depot
        };
        let config = {
          headers: {
            "Content-Type": "application/json"
          }
        };

        let res;
        if (!this.isUpdating) {
          res = await axios.post(endPoint, data, config);
        } else {
          res = await axios.patch(endPoint, data, config);
        }
        let resData = res.data;

        if (res.status === 201) {
          this.$emit("submitted", resData);
          this.$swal({
            title: resData,
            type: "success",
            confirmButtonText: "Okay"
          });
        } else {
          this.$swal({
            title: "Whoops!",
            text: resData,
            type: "warning",
            confirmButtonText: "Okay"
          });
          this.$emit("cancelled");
        }
      } catch (errors) {
        this.$swal({
          title: "Whoops!",
          text: "Something went wrong",
          type: "error",
          confirmButtonText: "Okay"
        });
        // Event.$emit("serverError");
        this.$emit("cancelled");
      }
    }
  },
  computed: {
    title() {
      return this.isUpdating
        ? "Edit Depot Bin Location"
        : "Assign Booking to Bin Location";
    },
    /**
     * Checks if the input fields have been touched. This is used to disable the submit button.
     */
    formInputsNotTouched() {
      for (let key in this.form) {
        if (this.form.hasOwnProperty(key) && this.form[key].touched === true) {
          return false;
        }
      }
      return true;
    }
  }
};
</script>

<style scoped></style>
